import { createAsyncThunk } from '@reduxjs/toolkit';

import type { INotificationAll } from '@/Module/Profile/Model/DataModel';
import NotificationService from '@/Module/Profile/Service/NotificationService';
import type { IState } from '@/Module/Store/Model';

import type { IGetAllNotification } from '../../Model/ApiModel';

export const getAllNotificationAction = createAsyncThunk<
  INotificationAll,
  Omit<IGetAllNotification, 'pageCount' | 'pageNo'>
>('notification/getAllNotificationAction', async (req, { signal, getState }) => {
  return NotificationService.getListNotification(
    { ...req, pageNo: (getState() as IState).notification.page, pageCount: (getState() as IState).notification.rows },
    signal,
  ).then(({ data: { data } }) => data);
});
